export default "__VITE_ASSET__CWYMAnSv__"